import ApiService from './ApiService';

export default class SettingApi extends ApiService {
    getSystemSetting(payload) {
        return this.get('setting', payload);
    }

    updateSetting(payload) {
        return this.put('setting', payload);
    }
}
